module.exports = __webpack_public_path__ + "static/media/deputy-belyaeva.446867c3.jpg";